import React, { useEffect, useState } from "react"
import { QueueProps, useFila } from "../../../../../context/FilaContext"
import { ClienteCard } from '../clienteCard'
import { verifyIcon } from "../../../../../utils/verifyIcons"
import { formatCPFCNPJ } from "../../../../../utils/formatCPFCNPJ"
import { Loader } from "../../../../generics/loader"
import { useIsFetching, useMutation, useQuery } from "@tanstack/react-query"
import { apiModulo } from "../../../../../services/api"
import { useAuth } from "../../../../../context/AuthContext"
import { useDividas } from "../../../../../context/DividasContext"
import { useModal } from "../../../../../hooks/ModalContext"

export const FilaOperador = () => {
  const [clientSelected, setClientSelected] = useState(0);
  const { onClose } = useModal();
  const { cookies } = useAuth()
  const { getDividas, devedor } = useDividas()
  const { getDevedorFilaSelected, devedorFilaSelected } = useFila()

  function verifySelected(id: number, id_queue: number) {
    return id_queue
  }

  const { data, isSuccess } = useQuery({
    queryKey: ['atendimento'], queryFn: async () => {
      const { data } = await apiModulo.get('/queues/2', { params: { startDate: '2023-03-01', endDate: '2024-11-20', operator: cookies?.user.id_operador } })
      return data
    },
    refetchOnWindowFocus: false
  })

  const mutationInicioAtt = useMutation({
    mutationFn: (id_queue: string) => {
      return apiModulo.put(`/queues/progress-queue/${id_queue}/`)
    },
  })

  async function inicioAtendimento(queue: QueueProps) {
    if (queue.cpf_cnpj !== devedor?.cpf_cnpj) {
      setClientSelected(verifySelected(clientSelected, Number(queue.id_queue)))
      if (!queue.date_start_service) {
        mutationInicioAtt.mutate(queue.id_queue)
      }
      getDevedorFilaSelected(queue)
      onClose()
      //limpar tds os dados aqui e dps fazer td
      await getDividas({ cpf_cnpj: queue.cpf_cnpj, codcredor: 0 })

    }
  }

  const isFetching = useIsFetching({ queryKey: ['atendimento'] })

  function mostrarFila() {
    return (isSuccess && data.queue?.length > 0) && data?.queue.map((queue: QueueProps) => (
      <div
        onDoubleClick={() => inicioAtendimento(queue)}
        className=" cursor-pointer hover:opacity-95"
        key={queue.id_queue}
      >
        <ClienteCard
          nome={queue.name}
          status={2}
          cpf={formatCPFCNPJ(queue.cpf_cnpj)}
          hora_fila={queue.date_assignment && !queue.date_start_service ? queue.date_assignment : queue.date_start_service && queue.date_start_service ? queue.date_start_service : queue.date_origin}
          isSelected={Number(queue.id_queue) === Number(devedorFilaSelected?.id_queue)}
          icon={verifyIcon(queue.channel.channel === 'E-mail' ? 'email' : queue.channel.channel.toLocaleLowerCase())}
          text={
            "Callback"
          }
        />
      </div>
    ))
  }

  return (
    <div className="max-h-[30%] min-h-[30%] overflow-y-auto overflow-x-hidden pr-1  ">
      {
        isFetching || !isSuccess ? (<div className=" flex justify-center items-center  min-h-[3rem]  ">
          <Loader />
        </div>) : mostrarFila()
      }

    </div>
  )
}